import { SearchComponent } from 'src/_shared/components/search';
import React from 'react';
import { Row, Col, Select, Button, Tooltip } from 'antd';
import { ml } from 'src/_shared/services/utils.js';
import { ToggleOpenClosedNew } from '../_shared/components/toggleOpenClosedNew';

const { Option } = Select;

export const AdvanceFilters = ({
	currentUser,
	bonuses,
	departments,
	subCompanies,
	jobLevels,
	availableOptions,
	filteredDate,
	filteredDepartments,
	filteredSubCompanies,
	filteredJobLevels,
	filteredAvailables,
	filteredSalary,
	hideBonusFilter,
	currencySymbol,
	handleFilterDate,
	handleFilterDepartment,
	handleRemoveDepartmentFilter,
	handleFilterSubCompany,
	handleRemoveSubCompanyFilter,
	handleFilterJobLevel,
	handleRemoveJobLevelFilter,
	handleFilterAvailable,
	handleFilterSalary,
	renderBonusRangeSlider,
	filterOpenStatus,
	handleFilterOpenStatus,
	openStatusText,
	visibleAdvance,
	filterTitle,
	handleToggleFilters,
	filteredDistance,
	address,
	handleLocationFilter,
	handleSetLocation,
	allMultiLingualData,
	searchQuery,
	setQueryToState,
	displaySearchFilter,
	loading,
	enableGeneralReferrals,
	showModalGeneral,
	isExtendedUser,
	jobFilterSettings,
	companyOptions,
	handleFilterCompany,
	handleRemoveCompanyFilter,
	noBonusValue,
	hideSubcompanyOnJobs,
	filteredCompensationGrades,
	filteredHiringManagers,
	compensationGradeOptions,
	hiringManagerOptions,
	handleFilterCompensationGrade,
	handleFilterHiringManager,
}) => {
	const subCompanyLabel = currentUser?.company?.subCompanyLabel || 'SubCompany';
	const departmentLabel = currentUser?.company?.labelDepartment || 'Department';

	const allowSelfReferralsInternalLink =
		currentUser?.company?.allowSelfReferralsInternalLink;

	return (
		<div
			className="browse-jobs-filters"
			style={{
				alignItems: 'flex-start',
				display: 'flex',
				flexWrap: 'wrap',
				justifyContent: 'space-between',
				width: '100%',
			}}
		>
			<div
				className="filter-wrap"
				style={{
					marginRight: '10px',
					flex: '1 1 auto',
					alignItems: 'center',
					display: 'flex',
					gap: '12px',
					flexWrap: 'wrap',
				}}
			>
				<Row gutter={[16, 16]} align="middle" style={{ marginBottom: '16px' }}>
					<Col flex="auto">
						{displaySearchFilter(
							<SearchComponent
								loading={loading}
								searchQuery={searchQuery}
								setQueryToState={setQueryToState}
								placeholder={ml(
									'Search by location, job name and/or keywords',
									currentUser,
									allMultiLingualData
								)}
							/>
						)}
					</Col>
					<Col>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<Select
								style={{ minWidth: '150px' }}
								placeholder={ml('Distance', currentUser, allMultiLingualData)}
								value={filteredDistance}
								onChange={handleLocationFilter}
							>
								<Option value="allLocations">
									{ml('All Locations', currentUser, allMultiLingualData)}
								</Option>
								<Option value="remote">
									{ml('Remote', currentUser, allMultiLingualData)}
								</Option>
								<Option value="within25">
									{ml('Within 25 miles', currentUser, allMultiLingualData)}
								</Option>
								<Option value="within50">
									{ml('Within 50 miles', currentUser, allMultiLingualData)}
								</Option>
								<Option value="within100">
									{ml('Within 100 miles', currentUser, allMultiLingualData)}
								</Option>
								<Option value="within200">
									{ml('Within 200 miles', currentUser, allMultiLingualData)}
								</Option>
								<Option value="myCountry">
									{ml('My Country', currentUser, allMultiLingualData)}
								</Option>
							</Select>
							<Button
								type="link"
								className="location-btn"
								onClick={handleSetLocation}
							>
								{address === '' ? (
									<>
										<span className="location-circle" />
										{ml('Set location', currentUser, allMultiLingualData)}
									</>
								) : (
									<div>
										<span className="location-circle" />
										{address}
									</div>
								)}
							</Button>
						</div>
					</Col>
					<Col>
						<Button type="link" onClick={() => handleToggleFilters()}>
							{filterTitle === 'Show Filters'
								? ml('Show Filters', currentUser, allMultiLingualData)
								: ml('Hide Filters', currentUser, allMultiLingualData)}
						</Button>
					</Col>
				</Row>
			</div>
			{enableGeneralReferrals &&
				currentUser &&
				currentUser.role !== 'extendedUser' && (
					<Button
						type="link"
						className="add-btn btn-lg"
						onClick={showModalGeneral}
					>
						<span className="icon-circle">
							<i className="icon-plus" />
						</span>
						{ml('Submit General Referral', currentUser, allMultiLingualData)}
					</Button>
				)}
			<div style={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap' }}>
				<div
					className={`filter-wrap advanced-filters ${visibleAdvance ? 'visible' : ''}`}
				>
					{!isExtendedUser && !jobFilterSettings?.closedJobs?.hidden && (
						<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
							<ToggleOpenClosedNew
								currentUser={currentUser}
								allMultiLingualData={allMultiLingualData}
								filterOpenStatus={filterOpenStatus}
								text={openStatusText}
								openJobs={ml('Open', currentUser, allMultiLingualData)}
								closedJobs={ml('Closed', currentUser, allMultiLingualData)}
								onClick={handleFilterOpenStatus}
							/>
						</div>
					)}
					{!isExtendedUser &&
					!hideBonusFilter &&
					bonuses &&
					bonuses?.length > 0 ? (
						<Tooltip
							placement="bottom"
							title={
								noBonusValue
									? ml(
											`No referral bonuses are currently available for ${filterOpenStatus} jobs.`,
											currentUser,
											allMultiLingualData
										)
									: null
							}
							style={{ fontWeight: 1000 }}
						>
							<div style={{ marginRight: '12px' }}>
								<div
									style={{
										display: 'inline-flex',
										color: '#000',
										marginRight: '12px',
										userSelect: 'none',
									}}
								>
									{ml('Bonus', currentUser, allMultiLingualData)}
								</div>
								{renderBonusRangeSlider && renderBonusRangeSlider()}
							</div>
						</Tooltip>
					) : null}
					{subCompanies && subCompanies.length > 0 && !hideSubcompanyOnJobs && (
						<Select
							mode="multiple"
							placeholder={ml(
								subCompanyLabel,
								currentUser,
								allMultiLingualData
							)}
							value={filteredSubCompanies}
							onChange={(values) => {
								values.forEach((value) => {
									if (!filteredSubCompanies.includes(value)) {
										handleFilterSubCompany(value);
									}
								});
								filteredSubCompanies.forEach((subComp) => {
									if (!values.includes(subComp)) {
										handleRemoveSubCompanyFilter(subComp);
									}
								});
							}}
							maxTagCount={2}
							maxTagTextLength={10}
							showSearch
							showArrow={true}
							filterOption={(input, option) => {
								return option.props.children
									.toLowerCase()
									.includes(input.toLowerCase());
							}}
						>
							{subCompanies &&
								Array.isArray(subCompanies) &&
								[...subCompanies]
									.sort((a, b) => (a.name || '').localeCompare(b.name || ''))
									.map((subComp) => (
										<Option key={subComp.id} value={subComp.id}>
											{subComp.name}
										</Option>
									))}
						</Select>
					)}
					{isExtendedUser && companyOptions && companyOptions.length > 1 && (
						<Select
							filterOption={(input, option) => {
								return option.props.children
									.toLowerCase()
									.includes(input.toLowerCase());
							}}
							mode="multiple"
							placeholder={ml(
								`${subCompanyLabel}`,
								currentUser,
								allMultiLingualData
							)}
							showArrow={true}
							onSelect={(company, { key }) => handleFilterCompany(company, key)}
							onDeselect={(company, { key }) =>
								handleRemoveCompanyFilter(company, key)
							}
						>
							{companyOptions}
						</Select>
					)}
					{jobLevels && jobLevels.length > 0 && (
						<Select
							mode="multiple"
							placeholder={ml(
								'Select job levels',
								currentUser,
								allMultiLingualData
							)}
							value={filteredJobLevels}
							onChange={(values) => {
								values.forEach((value) => {
									if (!filteredJobLevels.includes(value)) {
										handleFilterJobLevel(value);
									}
								});
								filteredJobLevels.forEach((level) => {
									if (!values.includes(level)) {
										handleRemoveJobLevelFilter(level);
									}
								});
							}}
							maxTagCount={2}
							maxTagTextLength={10}
							showSearch
							showArrow={true}
							filterOption={(input, option) => {
								return option.props.children
									.toLowerCase()
									.includes(input.toLowerCase());
							}}
						>
							{jobLevels &&
								Array.isArray(jobLevels) &&
								jobLevels.map((level) => (
									<Option key={level.id} value={level.id}>
										{level.name}
									</Option>
								))}
						</Select>
					)}
					{!isExtendedUser && !jobFilterSettings?.payRate?.hidden && (
						<Select
							placeholder={ml(
								'Min. Pay Rate',
								currentUser,
								allMultiLingualData
							)}
							value={filteredSalary}
							onChange={handleFilterSalary}
							allowClear
						>
							<Option value={30000}>{currencySymbol}30,000+</Option>
							<Option value={50000}>{currencySymbol}50,000+</Option>
							<Option value={75000}>{currencySymbol}75,000+</Option>
							<Option value={100000}>{currencySymbol}100,000+</Option>
							<Option value={150000}>{currencySymbol}150,000+</Option>
							<Option value={200000}>{currencySymbol}200,000+</Option>
						</Select>
					)}
					{!isExtendedUser && jobFilterSettings?.compensationGrade?.hidden === false &&
						compensationGradeOptions && compensationGradeOptions.length > 0 && (
						<Select
							mode="multiple"
							placeholder={ml(
								'Compensation Grade',
								currentUser,
								allMultiLingualData
							)}
							value={filteredCompensationGrades}
							onChange={handleFilterCompensationGrade}
							maxTagCount={2}
							maxTagTextLength={10}
							showSearch
							showArrow={true}
							allowClear
							filterOption={(input, option) => {
								return option.props.children
									.toString()
									.toLowerCase()
									.includes(input.toLowerCase());
							}}
						>
							{compensationGradeOptions.map((grade) => (
								<Option key={grade} value={grade}>
									{grade}
								</Option>
							))}
						</Select>
					)}
					{!isExtendedUser && jobFilterSettings?.hiringManager?.hidden === false &&
						hiringManagerOptions && hiringManagerOptions.length > 0 && (
						<Select
							mode="multiple"
							placeholder={ml(
								'Hiring Manager',
								currentUser,
								allMultiLingualData
							)}
							value={filteredHiringManagers}
							onChange={handleFilterHiringManager}
							maxTagCount={2}
							maxTagTextLength={10}
							showSearch
							showArrow={true}
							allowClear
							filterOption={(input, option) => {
								return option.props.children
									.toString()
									.toLowerCase()
									.includes(input.toLowerCase());
							}}
						>
							{hiringManagerOptions.map((manager) => (
								<Option key={manager.employeeId} value={manager.employeeId}>
									{manager.name}
								</Option>
							))}
						</Select>
					)}
					{!isExtendedUser && (
						<Select
							mode="multiple"
							placeholder={ml(
								departmentLabel,
								currentUser,
								allMultiLingualData
							)}
							value={filteredDepartments}
							onChange={(values) => {
								values.forEach((value) => {
									if (!filteredDepartments.includes(value)) {
										handleFilterDepartment(value);
									}
								});
								filteredDepartments.forEach((dept) => {
									if (!values.includes(dept)) {
										handleRemoveDepartmentFilter(dept);
									}
								});
							}}
							maxTagCount={2}
							maxTagTextLength={10}
							showSearch
							showArrow={true}
							filterOption={(input, option) => {
								return option.props.children
									.toString()
									.toLowerCase()
									.includes(input.toLowerCase());
							}}
						>
							{departments &&
								Array.isArray(departments) &&
								[...departments]
									.sort((a, b) => (a.name || '').localeCompare(b.name || ''))
									.map((dept) => (
										<Option key={dept.id} value={dept.id}>
											{dept.name}
										</Option>
									))}
						</Select>
					)}
					{!isExtendedUser && (
						<Select
							placeholder={ml('Created Date', currentUser, allMultiLingualData)}
							value={filteredDate}
							onChange={handleFilterDate}
							allowClear
						>
							<Option value={0}>
								{ml('All Time', currentUser, allMultiLingualData)}
							</Option>
							<Option value={1}>
								{ml('Yesterday (1 Day Ago)', currentUser, allMultiLingualData)}
							</Option>
							<Option value={7}>
								{ml('7 Days Ago', currentUser, allMultiLingualData)}
							</Option>
							<Option value={14}>
								{ml('14 Days Ago', currentUser, allMultiLingualData)}
							</Option>
							<Option value={30}>
								{ml('30 Days Ago', currentUser, allMultiLingualData)}
							</Option>
							<Option value={60}>
								{ml('60 Days Ago', currentUser, allMultiLingualData)}
							</Option>
							<Option value={90}>
								{ml('90 Days Ago', currentUser, allMultiLingualData)}
							</Option>
						</Select>
					)}
					{allowSelfReferralsInternalLink &&
						availableOptions &&
						availableOptions.length > 0 && (
							<Select
								placeholder={ml(
									'Select availability',
									currentUser,
									allMultiLingualData
								)}
								value={
									filteredAvailables.length > 0
										? filteredAvailables[0]
										: undefined
								}
								onChange={handleFilterAvailable}
								allowClear
								size="large"
							>
								{availableOptions &&
									Array.isArray(availableOptions) &&
									availableOptions.map((option) => (
										<Option key={option.key} value={option.key}>
											{option.props && option.props.children}
										</Option>
									))}
							</Select>
						)}
				</div>
			</div>
		</div>
	);
};
